/**
 * Departments Create Page — hardcoded form.
 */

import * as React from 'react';
import { useNavigate } from 'react-router';
import { useCreate } from '@refinedev/core';
import {
  Button, Card, CardContent, Input, Label, Textarea, Checkbox,
} from '@yesbos/ui';
import { ArrowLeft } from 'lucide-react';

export function DepartmentsCreatePage() {
  const navigate = useNavigate();
  const { mutate: create, isLoading } = useCreate();
  const [form, setForm] = React.useState({ name: '', code: '', description: '', is_active: true });
  const [error, setError] = React.useState<string | null>(null);
  const set = (f: string, v: unknown) => setForm(p => ({ ...p, [f]: v }));

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    create(
      { resource: 'departments', values: form },
      {
        onSuccess: () => navigate('/departments'),
        onError: (err: any) => setError(err?.message ?? 'Failed to create department. Please try again.'),
      },
    );
  }

  return (
    <div className="p-6 max-w-xl mx-auto">
      <div className="flex items-center gap-3 mb-6">
        <Button variant="ghost" size="icon" onClick={() => navigate('/departments')}><ArrowLeft className="h-4 w-4" /></Button>
        <h1 className="text-2xl font-semibold">Create Department</h1>
      </div>
      <Card>
        <CardContent className="pt-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <div className="rounded-md bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-700">
                {error}
              </div>
            )}
            <div className="space-y-1">
              <Label htmlFor="name">Name *</Label>
              <Input id="name" value={form.name} onChange={e => set('name', e.target.value)} required />
            </div>
            <div className="space-y-1">
              <Label htmlFor="code">Code</Label>
              <Input id="code" value={form.code} onChange={e => set('code', e.target.value)} placeholder="e.g. ENG, HR, FIN" />
            </div>
            <div className="space-y-1">
              <Label htmlFor="description">Description</Label>
              <Textarea id="description" value={form.description} onChange={e => set('description', e.target.value)} rows={3} />
            </div>
            <label className="flex items-center gap-2 cursor-pointer">
              <Checkbox checked={form.is_active} onCheckedChange={v => set('is_active', v)} />
              <span className="text-sm">Active</span>
            </label>
            <div className="flex justify-end gap-3 pt-2">
              <Button type="button" variant="outline" onClick={() => navigate('/departments')}>Cancel</Button>
              <Button type="submit" disabled={isLoading}>{isLoading ? 'Creating...' : 'Create Department'}</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}

export default DepartmentsCreatePage;
